import { useQuery } from "@tanstack/react-query";
import { fetchNotesList } from "../services/notesService";

function extractPagination(payload = {}) {
  const pagination = payload?.pagination || {};

  return {
    currentPage: Number(pagination?.currentPage || pagination?.current_page || 1),
    perPage: Number(pagination?.perPage || pagination?.per_page || 0),
    totalRecords: Number(pagination?.totalRecords || pagination?.total_records || 0),
    totalPages: Number(pagination?.totalPages || pagination?.total_pages || 1),
  };
}

function normalizeNote(item = {}, index = 0) {
  const serialNo = Number(item?.index || item?.serial_no || index + 1);

  return {
    id: Number(item?.notes_id || item?.note_id || item?.id || index + 1),
    serialNo,
    title: item?.name || item?.title || "Note will be available soon.",
    description: item?.description || item?.summary || "",
    stateId: Number(item?.state_id || 0),
    notesType: item?.notes_type || "",
    freePaid: item?.free_paid || "F",
    paymentStatus: Number(item?.payment_status || 0),
    isRead: Number(item?.view_status || item?.is_notes_read || item?.read_status || 0) === 1,
    viewLabel: item?.notes_view_at || "",
    isBookmarked: Number(item?.bookmark_status || 0) === 1,
    likeCount: Number(item?.total_likes || 0),
    viewCount: Number(item?.total_views || 0),
    reportCount: item?.total_reports || "0",
    notesCount: Number(item?.total_notes || 0),
    subscriptionMessage: item?.subscription_message || "",
    isBold: Number(item?.is_bold || 0) === 1,
    reportStatus: Number(item?.report_status || 0) === 1,
    raw: item,
  };
}

export function useNotesList(params = {}, options = {}) {
  return useQuery({
    queryKey: ["notesList", params],
    queryFn: async () => {
      const { payload } = await fetchNotesList(params);
      const rawNotes = payload?.notes_list || payload?.data || [];
      const pagination = extractPagination(payload);

      return {
        raw: payload,
        stateName: payload?.state_name || "",
        subjectName: payload?.subject_name || "",
        topicName: payload?.topic_name || "",
        categoryName: payload?.category_name || "",
        totalResults: Number(payload?.total_notes_count || pagination.totalRecords || 0),
        resetStatus: Number(payload?.reset_status || 0),
        resetMessage: payload?.reset_message || "",
        notes: (Array.isArray(rawNotes) ? rawNotes : []).map(normalizeNote),
        pagination,
      };
    },
    enabled: options.enabled ?? true,
    staleTime: 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnMount: "always",
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    placeholderData: (previousData) =>
      previousData ?? {
        stateName: "",
        subjectName: "",
        topicName: "",
        categoryName: "",
        totalResults: 0,
        resetStatus: 0,
        resetMessage: "",
        notes: [],
        pagination: {
          currentPage: 1,
          perPage: 0,
          totalRecords: 0,
          totalPages: 1,
        },
      },
  });
}
